import React from 'react';

import { clsx } from 'clsx';

import styles from './GradientButton.scss';

type ButtonProps = React.ComponentPropsWithoutRef<'button'> & { darkGradient?: boolean };

const GradientButton = (props: ButtonProps) => (
  <button
    {...props}
    className={clsx(styles.lightGradient, props.className, {
      [styles.darkGradient]: props.darkGradient,
    })}
  >
    {props.children}
  </button>
);

export default GradientButton;
